/**
 * "A booking's status may just have moved" — the quick ring (QR6).
 *
 * Announced when the ring checks a patient in or seats them, and heard by the
 * calendar and Home, which read the day again. The ring acts on a screen it
 * does not own, so without this the block it just moved would keep its old
 * status until the next reload.
 */
export const APPOINTMENTS_CHANGED = "dentacore:appointments-changed";

export function announceAppointmentsChanged(): void {
  window.dispatchEvent(new Event(APPOINTMENTS_CHANGED));
}
